import { render, staticRenderFns } from "./declaration_info.vue?vue&type=template&id=4e7a188a&scoped=true&"
import script from "./declaration_info.vue?vue&type=script&lang=js&"
export * from "./declaration_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7a188a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e7a188a')) {
      api.createRecord('4e7a188a', component.options)
    } else {
      api.reload('4e7a188a', component.options)
    }
    module.hot.accept("./declaration_info.vue?vue&type=template&id=4e7a188a&scoped=true&", function () {
      api.rerender('4e7a188a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/declaration/item/declaration_info.vue"
export default component.exports